import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { history } from '../components/CustomRouter';

import * as reducers from '../store';

const resetLoadingTransform = createTransform(
  (inboundState: any) => inboundState,
  (outboundState: any) => ({ ...outboundState, loading: false }),
  { whitelist: ['auth'] },
);

const persisConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
  transforms: [resetLoadingTransform],
};

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
});
const persistedReducer = persistReducer(persisConfig, rootReducer);

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          '@@router/LOCATION_CHANGE',
          'persist/PERSIST',
          'persist/REHYDRATE',
        ],
      },
    }).concat(routerMiddleware(history)),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
